import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  box: {
    width: '100%',

    '& > div': {
      borderTop: '1px solid #E0E0E0',

      '& > div': {
        padding: theme.spacing(1, 0),

        '&:first-child': {
          textAlign: 'center',
          width: '5%',
        },
        '&:nth-child(2)': {
          width: '45%',
        },
        '&:nth-child(3)': {
          textAlign: 'center',
          width: '5%',
          '& svg': {
            fill: '#e0e0e0',
          },
        },
        '&:last-child': {
          width: '44%',
        },
      },
    },
  },
  title: {
    textTransform: 'uppercase',
    padding: theme.spacing(3, 0),
    lineHeight: '3em',
    fontWeight: 'bold',
  },
}));
